import React, { useCallback, memo } from 'react';
import cx from 'clsx';
import { IconEnter } from 'assets/overview';

import './index.css';
import { SelectOption, SearchSelectOptionProps } from './types';

export const SearchSelectOption = memo(
  ({
    label,
    idx,
    activeIdx = 0,
    value,
    showSuffix = true,
    renderOption,
    onOptionClick,
  }: SearchSelectOptionProps) => {
    const handleClick = useCallback(event => onOptionClick(idx, event), [onOptionClick, idx]);

    // prevent input blur fire
    const handleDown = useCallback(event => event.preventDefault(), []);

    return (
      <div
        className={cx('searchSelect-option', idx === activeIdx && 'searchSelect-option--active')}
        data-idx={idx}
        onPointerDown={handleDown}
        onClick={handleClick}>
        {renderOption ? renderOption({ label, value }) : label}
        {showSuffix && idx === activeIdx && <img src={IconEnter} alt="enter" />}
      </div>
    );
  },
);

export const SearchSelectOptionPanel = memo(
  ({
    options,
    lastIdx = 0,
    activeIdx = 0,
    renderOption,
    onOptionClick,
    showSuffix,
  }: {
    options: SelectOption[];
    lastIdx?: number;
    activeIdx?: number;
    showSuffix?: boolean;
    renderOption?: SearchSelectOptionProps['renderOption'];
    onOptionClick: SearchSelectOptionProps['onOptionClick'];
  }) => {
    let i = lastIdx;

    // 深度遍历节点，递增序号
    return (
      <>
        {options.map((option, idx) => {
          if (option.children) {
            i += lastIdx + (options[idx - 1]?.children?.length || 0);

            return option.children?.length ? (
              <div className="searchSelect-optionGroup">
                <div className="searchSelect-optionGroupTitle">{option.label}</div>
                <SearchSelectOptionPanel
                  options={option.children}
                  renderOption={renderOption}
                  lastIdx={i}
                  activeIdx={activeIdx}
                  onOptionClick={onOptionClick}
                  showSuffix={showSuffix}
                />
              </div>
            ) : null;
          }

          return (
            <SearchSelectOption
              activeIdx={activeIdx}
              idx={i++}
              renderOption={renderOption}
              label={option.label}
              value={option.value}
              onOptionClick={onOptionClick}
              showSuffix={showSuffix}
            />
          );
        })}
      </>
    );
  },
);

export const NotFoundContent = ({ placeholder }: { placeholder?: string }) => (
  <div className={'searchSelect-notFoundContent'}>{placeholder || 'No Match'}</div>
);
